<template>
    <div>
      <lot-details v-if="lot" :lot="lot"></lot-details>
      <loading v-if="loading"></loading>
    </div>
</template>

<script>
  import LotDetails from './Details'
  import Vue from "vue";
  import CommonMixins from './mixins/common'

  export default {
    components: {
      LotDetails
    },

    mixins: [
      CommonMixins
    ],

    data: () => ({
      lotCopy: undefined,
      lotCopyWatcher: undefined
    }),

    computed: {
      lotId() {
        return +this.$route.params.lotId;
      },

      lot() {
        return this.$store.getters.publicLot(this.lotId);
      }
    },

    beforeRouteEnter(to, from, next) {
      next(async vm =>  {
        await vm.loadRequest(to.params.lotId);
        vm.validateRoute(to);
      });
    },

    async beforeRouteUpdate(to, from, next) {
      if (from.params.lotId !== to.params.lotId) {
        await this.loadRequest(to.params.lotId);
      }
      this.validateRoute(to);
      next();
    },

    methods: {
      loadRequest(lotId) {
        return this.runBlockerAction(async () => {
          try {
            await this.$store.dispatch('fetchPublicLot', { lotId: lotId });
          }
          catch(e) {
            console.error('failed fetching public lot', e);
            this.globalErrorHandler(e);
          }
        });
      },

      validateRoute(to) {
        const tab = to.params.tab;
        let bidId;

        if (tab.indexOf('bidnum-') === 0) {
          const bidNum = +tab.slice(7);
          const bids = _.get(this.lot, 'request.bids', []);
          bidId = _.get(_.find(bids, { num: bidNum }), 'id');
        }

        if (bidId) {
          // redirect to bid by id
          this.$router.replace({
            name: 'purchases-my-lots-details',
            params: {
              lotId: this.lot.id,
              tab: 'bid-' + bidId
            }
          });
        }
      }
    }
  }
</script>

<style scoped>

</style>
